import React from 'react';

import alustechicon from './../assets/images/alustech-icon.png';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer">
            <img src={alustechicon} alt="Logo" height="20" className="mr-2" />
            <span className="font-medium ml-2">
                <a href='http://alustech.com.br'>Alustech</a>
            </span>
        </div>
    );
}
